import {
  AdvancedFilterInputSchema,
  fulfillmentGroupFilterNames,
} from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getFulfillmentGroupUniqueValues = {
  name: "getFulfillmentGroupUniqueValues" as const,
  input: AdvancedFilterInputSchema.extend({
    filterName: createEnum(fulfillmentGroupFilterNames),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
